import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-rowcal-preferred-vendor-terms',
  templateUrl: './rowcal-preferred-vendor-terms.component.html',
  styleUrls: ['./rowcal-preferred-vendor-terms.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RowcalPreferredVendorTermsComponent implements OnInit {
  pdfUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const pdfPath = 'assets/documents/rowcal/preferred-vendor-terms.pdf';
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfPath);
  }
}
